import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { RouteConstants } from '../../Constants/routeConstants'
import './ContactUs.scss'

const ContactUs: React.FC = () => {
  const navigate = useNavigate()
  const d = new Date()
  const year = d.getFullYear()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false)
      alert('Thank you for your message! We will get back to you soon.')
      setFormData({ name: '', email: '', subject: '', message: '' })
    }, 2000)
  }

  return (
    <div className="contact-us-container">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="hero-content">
          <div className="contact-badge">
            <i className="fa fa-envelope"></i>
            Get in Touch
          </div>
          <h1>We're Here to Help</h1>
          <p>Have questions about LivingLegacy.me? Our team is ready to assist you with any inquiries about preserving your stories and creating meaningful legacies.</p>
        </div>
      </div>

      {/* Main Contact Section */}
      <div className="contact-main">
        <div className="contact-container" style={{backgroundColor:'none !important',background:"none !important"}}>
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info-section">
              <div className="info-card">
                <div className="card-header">
                  <i className="fa fa-info-circle"></i>
                  <h2>Contact Information</h2>
                </div>
                
                <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <div className="method-content">
                    <h3>Email Support</h3>
                    <p>support@livinglegacy.me</p>
                    <span className="response-time">Response within 24 hours</span>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">
                    <i className="fa fa-user"></i>
                  </div>
                  <div className="method-content">
                    <h3>Contact</h3>
                    <p>Henry Scott, CEO</p>
                    <span className="response-time">bigfatcoupon@gmail.com</span>
                  </div>
                </div>

                  <div className="contact-method">
                    <div className="method-icon">
                      <i className="fa fa-clock"></i>
                    </div>
                    <div className="method-content">
                      <h3>Business Hours</h3>
                      <p>Monday - Friday</p>
                      <span className="response-time">9:00 AM - 6:00 PM EST</span>
                    </div>
                  </div>

                  <div className="contact-method">
                    <div className="method-icon">
                      <i className="fa fa-comments"></i>
                    </div>
                    <div className="method-content">
                      <h3>Live Chat</h3>
                      <p>Available during business hours</p>
                      <span className="response-time">Instant response</span>
                    </div>
                  </div>
                </div>

                <div className="help-topics">
                  <h3>How Can We Help?</h3>
                  <ul>
                    <li><i className="fa fa-check"></i> Account setup and management</li>
                    <li><i className="fa fa-check"></i> Video recording assistance</li>
                    <li><i className="fa fa-check"></i> Privacy and security questions</li>
                    <li><i className="fa fa-check"></i> Technical support</li>
                    <li><i className="fa fa-check"></i> Billing and subscription</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-section">
              <div className="form-card">
                <div className="card-header">
                  <i className="fa fa-paper-plane"></i>
                  <h2>Send us a Message</h2>
                </div>
                
                <form onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter your email address"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      placeholder="What's this about?"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows={6}
                      placeholder="Tell us how we can help you..."
                    ></textarea>
                  </div>

                  <button 
                    type="submit" 
                    className="submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fa fa-spinner fa-spin"></i>
                        Sending...
                      </>
                    ) : (
                      <>
                        Send Message
                        <i className="fa fa-arrow-right"></i>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      {/* <div className="contact-faq">
        <div className="container">
          <div className="faq-content">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3>How do I create my first video message?</h3>
                <p>Simply sign up for an account, click "Create a Video" in your dashboard, and follow the step-by-step recording process. Our platform guides you through the entire process.</p>
              </div>
              <div className="faq-item">
                <h3>Is my content private and secure?</h3>
                <p>Yes, we take privacy seriously. All your content is encrypted and stored securely. You have complete control over who can view your legacy messages.</p>
              </div>
              <div className="faq-item">
                <h3>Can I share my legacy with family members?</h3>
                <p>Absolutely! You can invite family members to view your legacy messages. They'll receive secure access to your content and can add their own memories.</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div id="PreFooter">
        <div className="content">
          <h3>Create a Legacy in Minutes</h3>
          <button
            onClick={() => {
              navigate('/search')
            }}
            type="button"
            className="getStarted"
          >
            SEARCH
          </button>
        </div>
      </div>
      
      <footer className="Footer">
        <div className="container">
          <div className="footer-contact">Contact | Henry Scott CEO bigfatcoupon@gmail.com</div>
          <ul>
            <li>
              <a target="_blank" href={RouteConstants.TERMCONDITION} rel="noreferrer">
                Terms of Service
              </a>
            </li>
            <li>
              <a target="_blank" href={RouteConstants.PRIVACYPOLICY} rel="noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>© {year} Living Legacy Co. All rights reserved</li>
          </ul>
          <p
            className="hidden-link"
            onClick={() => {
              navigate(RouteConstants.PUBLICPAGES)
            }}
          >
            Pages
          </p>
        </div>
      </footer>
    </div>
  )
}

export default ContactUs 
